'use client';

import Script from 'next/script';
import { isProd, shiftDigitalAdobeTagManagerId } from '~/constants/environment';

declare global {
  interface Window {
    adobeDataLayer?: Array<Record<string, any>>;
  }
}

const script = isProd
  ? `launch-${shiftDigitalAdobeTagManagerId}.min.js`
  : `launch-${shiftDigitalAdobeTagManagerId}-staging.min.js`;

export default function AdobeTagManager() {
  return (
    <Script
      src={`https://assets.adobedtm.com/81f4df3a67c9/365a87734159/${script}`}
      strategy="beforeInteractive"
    />
  );
}
